/* ============================================================================
   Big Z's home, Direction 1 (2026-10-21, redesign)
   Zone tiles: one panel open at a time, aria-expanded / aria-controls, Escape closes.
   Just Landed quick add: the size is the listing's first available variant; the starter kit is
   worked out by BZP.rules (assets/bz-pathways.js), the same rules and the same data shape as the
   product page starter kit (snippets/bz-habitat-addon), so a fella gets the same kit in both places.
   A kit that is short on stock or carries a Needs verification note is not offered here: the
   shopper goes to the builder instead. Adds through BZP.addItems.
   Markup and data: snippets/bz-d1-sections. Styles: snippets/bz-d1-style.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-bzd1]');
  if (!root || root.hasAttribute('data-bzd1-ready')) return;
  root.setAttribute('data-bzd1-ready', '');
  var phone = window.matchMedia('(max-width: 900px)');
  var all = function (sel, el) { return [].slice.call((el || root).querySelectorAll(sel)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- zone tiles ---------- */
  var tiles = all('[data-bzd1-zone]');
  function setZone(b, open) {
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    var p = document.getElementById(b.getAttribute('aria-controls'));
    if (p) p.hidden = !open;
  }
  function openTile() { for (var i = 0; i < tiles.length; i++) { if (tiles[i].getAttribute('aria-expanded') === 'true') return tiles[i]; } return null; }
  tiles.forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') !== 'true';
      tiles.forEach(function (t) { if (t !== b) setZone(t, false); });
      setZone(b, open);
    });
  });

  /* ---------- quick add ---------- */
  var shared;
  function kitData() {
    if (shared === undefined) {
      var el = root.querySelector('[data-bzd1-kitdata]');
      try { shared = el ? JSON.parse(el.textContent) : null; } catch (e) { shared = null; }
    }
    return shared;
  }
  function rules() { return window.BZP && window.BZP.rules; }
  function money(cents) {
    var r = rules(), sh = kitData();
    return r ? r.money(cents, sh && sh.money_format) : '$' + (Number(cents || 0) / 100).toFixed(2);
  }
  var LANES = { baby: 'Baby Buddy', burrow: 'Burrow Buddy', bark: 'Bark Buddy' };

  // The product page module's answer (BZP.habitat render), minus the parts this panel routes to the builder.
  function kitFor(f) {
    if (!f.live) return null;
    var r = rules(), sh = kitData();
    if (!r || !sh) return { builder: true, line: 'Pick its enclosure, substrate and hide in the builder.' };
    var data = { product: f.product, guide: f.guide, enclosures: sh.enclosures || [], mixes: sh.mixes || {}, accessories: sh.accessories || {} };
    var ctx = r.context(data, f.product.selected);
    var pick = r.pickBox(data, ctx);
    if (!pick.rec) return { builder: true, line: pick.verify || 'This fella needs a custom build.' };
    if (pick.all) return { builder: true, line: pick.verify || 'Pick the box for this size in the builder.' };
    var sub = r.substrateFor(data, ctx, pick.rec);
    if (sub && sub.short) {
      var unit = /1\/4/.test(sub.variant.title) ? ' quarter-quart bags' : ' qt';
      return { builder: true, line: 'This fella’s box takes ' + sub.n + unit + ' of ' + sub.title + ' and ' + sub.stock + ' ' + (sub.stock === 1 ? 'is' : 'are') + ' in stock right now. Pick the box and the fill in the builder.', verify: pick.verify };
    }
    if (pick.verify) return { builder: true, line: 'Pick the box in the builder.', verify: pick.verify };
    var hide = r.hideFor(data, ctx, pick.rec);
    var dish = ctx.stage !== 'sling' ? r.dishFor(data) : null;
    var cup = ctx.spice >= 4 ? r.accessory(data, '24-oz-flip-top-plastic-enclosure') : null;
    if (ctx.spice >= 4 && !cup) return { builder: true, line: 'The catch cup for a Spice ' + ctx.spice + ' kit is not in stock right now.' };
    var items = [{ id: pick.rec.vid, n: 1, label: pick.rec.title, price: pick.rec.price, ok: pick.rec.available !== false }];
    if (sub) items.push({ id: sub.variant.vid, n: sub.n, label: sub.label, price: sub.price, ok: sub.variant.available !== false });
    if (hide) items.push({ id: hide.variant.vid, n: 1, label: hide.title, price: hide.price, ok: hide.variant.available !== false });
    if (dish) items.push({ id: dish.variant.vid, n: 1, label: dish.title, price: dish.price, ok: dish.variant.available !== false });
    if (cup) items.push({ id: cup.variant.vid, n: 1, label: cup.title + ' (catch cup)', price: cup.price, ok: cup.variant.available !== false });
    if (items.some(function (i) { return !i.ok; })) return { builder: true, line: 'Part of this kit is out of stock right now. Pick a swap in the builder.' };
    var total = items.reduce(function (t, i) { return t + i.price; }, 0);
    var units = items.reduce(function (t, i) { return t + i.n; }, 0);
    // Dry Goods 3+ / 6+ / 12+ automatic discounts, per unit with the fraction of a cent dropped,
    // the same math as the builder summary, so the button total is what the bag charges.
    var pct = units >= 12 ? 0.2 : units >= 6 ? 0.15 : units >= 3 ? 0.1 : 0;
    var disc = items.reduce(function (t, i) { return t + Math.floor((i.price / i.n) * pct) * i.n; }, 0);
    var notes = [];
    if (pick.rec.max != null) notes.push('Rated for up to ' + pick.rec.max + ' in of leg span.');
    if (ctx.stage === 'sling') notes.push('No dish for a sling; it drinks from a damp corner.');
    if (cup) notes.push('The catch cup is part of a Spice ' + ctx.spice + ' kit: rehousing and maintenance, never a hand.');
    if (pct) notes.push('Dry goods ' + (units >= 12 ? '12' : units >= 6 ? '6' : '3') + '+ take ' + Math.round(pct * 100) + '% off at checkout, so the kit rings up at ' + money(total - disc) + '.');
    return { title: (pick.rec.kind === 'cup' ? 'Sling cup' : (LANES[ctx.lane] || 'Starter')) + ' setup', total: total, disc: disc, items: items, units: units, note: notes.join(' ') };
  }

  var dock = document.getElementById('bzd1-qa-dock');
  var current = null;
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function state(card) {
    if (card._bzd1) return card._bzd1;
    var el = card.querySelector('script[data-bzd1-fella]'), f;
    try { f = JSON.parse(el.textContent); } catch (e) { return null; }
    var vs = (f.product && f.product.variants) || [];
    var v = vs.filter(function (x) { return String(x.vid) === String(f.product.selected); })[0] || vs[0];
    if (!v) return null;
    card._bzd1 = { f: f, v: v, btn: card.querySelector('[data-bzd1-qa]'), pop: card.querySelector('.bzd1-qa-pop') };
    return card._bzd1;
  }
  function ship(f) { return root.getAttribute(f.live ? 'data-bzd1-ship-live' : 'data-bzd1-ship-dry') || ''; }

  function html(c) {
    var f = c.f, v = c.v, k = c.kit;
    var top = '<div class="bzd1-qa__top"><span class="bzd1-qa__k">Quick add</span><button type="button" class="bzd1-qa__x" data-bzd1-close aria-label="Close quick add">' + ICON_X + '</button></div>';
    if (c.added) {
      return top + '<div class="bzd1-qa__okwrap"><span class="bzd1-qa__ok" aria-hidden="true">' + ICON_OK + '</span><p class="bzd1-qa__done" tabindex="-1" data-bzd1-focus>In your bag</p><p class="bzd1-qa__meta">' + esc(c.added) + '</p>' + (c.bag ? '<p class="bzd1-qa__meta" data-bzd1-bag>' + esc(c.bag) + '</p>' : '') + '</div>'
        + '<a class="bzd1-btn" href="/cart">View bag</a><button type="button" class="bzd1-btn bzd1-btn--ghost" data-bzd1-close>Keep shopping</button>';
    }
    var size = v.title && v.title !== 'Default Title' ? '<p class="bzd1-qa__meta">' + esc(v.title) + '</p>' : '';
    var spice = f.spice > 0 ? '<p class="bzd1-qa__spice"><span class="bzd1-dot bzd1-dot--' + f.spice + '" aria-hidden="true"></span>Spice ' + f.spice + ' · ' + esc(f.spice_name) + '</p>' : '';
    var out = top + '<div class="bzd1-qa__who"><p class="bzd1-qa__name" tabindex="-1" data-bzd1-focus>' + esc(f.name) + '</p>' + size + spice + '</div>';
    if (k && !k.builder) {
      out += '<div class="bzd1-kit"><span class="bzd1-kit__k">Starter kit for this animal</span><span class="bzd1-kit__head"><span class="bzd1-kit__t">' + esc(k.title) + '</span><span class="bzd1-kit__p">' + money(k.total) + '</span></span>'
        + '<span class="bzd1-kit__items">' + k.items.map(function (i) { return esc(i.label); }).join(' · ') + '</span>' + (k.note ? '<span class="bzd1-kit__note">' + esc(k.note) + '</span>' : '') + '</div>'
        + '<button type="button" class="bzd1-btn" data-bzd1-add="kit">Fella + starter kit · ' + money(v.price + k.total - k.disc) + '</button>'
        + '<button type="button" class="bzd1-btn bzd1-btn--ghost" data-bzd1-add="fella">Just the fella · ' + money(v.price) + '</button>';
    } else if (k) {
      out += '<div class="bzd1-kit" data-bzd1-route="builder"><span class="bzd1-kit__k">Setup in the builder</span><span class="bzd1-kit__items">' + esc(k.line) + '</span>' + (k.verify ? '<span class="bzd1-kit__note"><b>Check the fit.</b> ' + esc(k.verify.replace(/\s*Needs verification\.?$/, '')) + '</span>' : '') + '</div>'
        + '<button type="button" class="bzd1-btn" data-bzd1-add="fella">Add the fella · ' + money(v.price) + '</button>'
        + '<a class="bzd1-qa__link" href="' + esc(f.builder) + '">Pick its setup in the builder <span aria-hidden="true">&rarr;</span></a>';
    } else {
      out += '<button type="button" class="bzd1-btn" data-bzd1-add="fella">Add to bag · ' + money(v.price) + '</button>';
    }
    if (c.err) out += '<p class="bzd1-qa__err" role="alert">' + esc(c.err) + '</p>';
    return out + '<p class="bzd1-qa__foot">' + esc(ship(f)) + ' <a href="' + esc(f.url) + '">Full details <span aria-hidden="true">&rarr;</span></a></p>';
  }
  function paint(card, focus) {
    var c = card._bzd1;
    c.panel.innerHTML = html(c);
    if (focus) { var fo = c.panel.querySelector('[data-bzd1-focus]'); if (fo) fo.focus({ preventScroll: !phone.matches }); }
  }
  function open(card) {
    if (current && current !== card) close(current, false);
    var c = state(card);
    if (!c) return;
    c.added = ''; c.err = ''; c.busy = false;
    c.kit = kitFor(c.f);
    c.panel = phone.matches && dock ? dock : c.pop;
    c.btn.setAttribute('aria-controls', c.panel.id);
    c.panel.setAttribute('aria-label', 'Quick add, ' + c.f.name);
    c.panel.hidden = false;
    c.btn.setAttribute('aria-expanded', 'true');
    current = card;
    paint(card, true);
  }
  function close(card, refocus) {
    var c = card._bzd1;
    if (!c) return;
    if (c.panel) { c.panel.hidden = true; c.panel.innerHTML = ''; }
    c.btn.setAttribute('aria-expanded', 'false');
    if (current === card) current = null;
    if (refocus) c.btn.focus({ preventScroll: true });
  }
  // Reads the bag after an add: updates the header and dock counts, returns the bag line for the panel.
  function bagLine() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var n = String(j.item_count);
      document.querySelectorAll('.zx-tools button[aria-label="Open shopping bag"] span, .zx-dock button:last-of-type b').forEach(function (el) { el.textContent = n; });
      return 'Bag: ' + j.item_count + ' item' + (j.item_count === 1 ? '' : 's') + ', ' + money(j.total_price) + '.';
    }).catch(function () { return ''; });
  }
  function add(card, what) {
    var c = card._bzd1;
    if (!c || c.busy) return;
    var kit = what === 'kit' && c.kit && !c.kit.builder ? c.kit : null;
    var items = [{ id: c.v.vid, quantity: 1 }], units = 1;
    if (kit) kit.items.forEach(function (i) { items.push({ id: i.id, quantity: i.n }); units += i.n; });
    var addItems = window.BZP && window.BZP.addItems;
    if (!addItems) { c.err = 'The bag is still loading. Try again in a second.'; paint(card, false); return; }
    c.busy = true;
    all('[data-bzd1-add]', c.panel).forEach(function (b) { b.disabled = true; });
    Promise.resolve(addItems(items)).then(bagLine).then(function (line) {
      c.busy = false; c.err = ''; c.bag = line;
      c.added = kit ? c.f.name + ' and its ' + kit.title + ', ' + units + ' items in one go.' : c.f.name + (c.v.title && c.v.title !== 'Default Title' ? ', ' + c.v.title : '') + '.';
      paint(card, true);
      if (window.clarity) { try { window.clarity('set', 'bz_d1_quick_add', kit ? 'kit' : 'fella'); } catch (e) { } }
    }).catch(function (err) {
      c.busy = false;
      c.err = 'Could not add: ' + ((err && err.message) || 'try again') + '.';
      paint(card, false);
    });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bzd1-qa],[data-bzd1-close],[data-bzd1-add]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-bzd1-qa')) {
      var card = t.closest('[data-bzd1-card]');
      if (current === card) close(card, true); else open(card);
      return;
    }
    if (!current) return;
    if (t.hasAttribute('data-bzd1-close')) { close(current, true); return; }
    add(current, t.getAttribute('data-bzd1-add'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (current) { close(current, true); return; }
    var z = openTile();
    if (z) { setZone(z, false); z.focus(); }
  });
  var onBp = function () { if (current) close(current, false); };
  if (phone.addEventListener) phone.addEventListener('change', onBp); else if (phone.addListener) phone.addListener(onBp);
})();
